export const ROLE_LABELS = { employer: "Dispatcher", driver: "Driver", client: "Customer", super_admin: "Old owner-level login" };

export const roleLabel = (role) => ROLE_LABELS[role] || role || "—";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");

export const REASON_LABELS = {
  bad_password: "Wrong password",
  user_not_found: "No such account",
  suspended: "Suspended account",
  demo_blocked: "Demo account on live site",
  demo_password: "Public demo password",
};

export const ACTION_LABELS = {
  owner_suspended_account: "Suspended an account",
  owner_restored_account: "Restored an account",
  owner_emailed_reset_link: "Emailed a reset link",
  owner_recovery_email_requested: "Requested recovery email code",
  owner_recovery_email_set: "Set recovery email",
};

export const deviceLabel = (ua = "") => {
  const os = /Android/.test(ua) ? "Android" : /iPhone|iPad/.test(ua) ? "iPhone/iPad" : /Windows/.test(ua) ? "Windows"
    : /Mac OS/.test(ua) ? "Mac" : /Linux/.test(ua) ? "Linux" : "";
  const browser = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Firefox\//.test(ua) ? "Firefox"
    : /Safari\//.test(ua) ? "Safari" : /curl|python|requests/i.test(ua) ? "Script" : "";
  return [os, browser].filter(Boolean).join(" · ") || "Unknown";
};

export const planLabel = (c) => {
  if (c.id === null) return "—";
  if (c.subscription_status === "active") return "Active plan";
  if (c.is_trial || c.subscription_status === "trial") {
    const end = c.trial_end_date ? new Date(c.trial_end_date) : null;
    if (end && end < new Date()) return "Trial ended";
    return end ? `Trial to ${end.toLocaleDateString()}` : "Trial";
  }
  return "No plan";
};
